<div class="page-container" [class.loading]="isLoading">
    <app-header
        [title]="'benefits.benefitsPayroll.uploadBenefitsMonthlyStatement'"
        [back]="true"
        [backRoute]="benefitSettingsRoute"
    ></app-header>

    <ui-banner iconOverride="info">
        <p
            [innerHtml]="
                'benefits.benefitsPayroll.benefitsPremiumsWillOnlyApplyToEmployeesWhoAreAddedToPayroll' | translate
            "
        ></p>
    </ui-banner>

    <form #form="ngForm">
        <ui-card>
            <app-header [title]="'benefits.benefitsPayroll.stepOne'"></app-header>

            <div class="grid-row">
                <mat-form-field>
                    <mat-label appRemoveAriaOwns>{{
                        'benefits.benefitsPayroll.selectBenefitsProvider' | translate
                    }}</mat-label>
                    <mat-select
                        [(ngModel)]="benefitInvoice.benefitProviderId"
                        required
                        #benefitProvider="ngModel"
                        name="benefitProviderId"
                        placeholder="{{ 'benefits.benefitsPayroll.selectYourProvider' | translate }}"
                        (ngModelChange)="benefitProviderUpdated()"
                    >
                        @for (benefitProvider of benefitProviders; track benefitProvider) {
                            <mat-option [value]="benefitProvider.id">
                                {{ benefitProvider.name }}
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="benefitProvider.invalid">{{ benefitProvider.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
            <div class="grid-row">
                <app-month-year-picker
                    label="{{ 'benefits.benefitsPayroll.selectTheMonth' | translate }}"
                    placeholder="{{ 'benefits.benefitsPayroll.selectAMonth' | translate }}"
                    name="period"
                    [(ngModel)]="benefitInvoice.period"
                    required
                    #period="ngModel"
                >
                </app-month-year-picker>
            </div>
        </ui-card>

        <ui-card>
            <app-header [title]="'benefits.benefitsPayroll.stepTwo'"></app-header>

            <p>
                {{ 'benefits.benefitsPayroll.uploadYourBenefitsBillToHumi' | translate }}
            </p>

            @if (!invoiceFile) {
                <app-file-drop
                    (filesSelected)="onInvoiceUploaded($event)"
                    [allowedTypes]="allowedFileTypes"
                    [showAllowableTypes]="true"
                    [required]="true"
                ></app-file-drop>

                @if (form.submitted) {
                    <mat-error>
                        <span class="margin-top-1 margin-bottom-1"
                            >{{ 'benefits.benefitsPayroll.invoiceIsRequired' | translate }}
                        </span></mat-error
                    >
                }
            } @else {
                <div class="uploaded-file flex">
                    <mat-icon svgIcon="documentFile" class="margin-right-1"></mat-icon>
                    <span class="margin-right-1">{{ invoiceFile.name }}</span>
                    <ui-button class="margin-left-auto" type="icon" [size]="'no-padding'" (click)="removeDocument()">
                        <div class="sr-only">{{ 'remove' | translate }}</div>
                        <mat-icon svgIcon="close"></mat-icon>
                    </ui-button>
                </div>
            }
        </ui-card>
    </form>

    <div class="flex row justify-end">
        <ui-button [routerLink]="benefitSettingsRoute">{{ 'cancel' | translate }} </ui-button>
        <ui-button type="primary" (click)="save(form)">{{ 'save' | translate }} </ui-button>
    </div>
</div>
